import React from "react";
import { unslufigy } from "../../helpers/StringHelper";
import store from "../../Store";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { toggleOrganizationFailedSiteFilter } from "./OgranizationFailed-Action";
import getOrganization from "../../ajax/actions/organization/organization_get";

class OrganizationFailedFilters extends React.Component {
  componentDidMount() {
    store.dispatch(getOrganization(this.props.organization_id));
  }

  toggleFilter = (e) => {
    store.dispatch(toggleOrganizationFailedSiteFilter(e));
  };

  render() {
    let { title, params, organization } = this.props;

    return (
      <div className="heading-block pr-60">
        <div className="title-block">
          <h2>{unslufigy(title)}</h2>
          <div>
            <span>
              <Link to="/organizations">Organizations</Link>
            </span>
            <span>{organization}</span>
            <span>Failed Organization Transactions</span>
          </div>
        </div>
        <div className="search-bar">
          <input
            type="text"
            className="form-control"
            name="q"
            placeholder={`Search Failed Organization Transactions`}
            value={params.q}
            onChange={(e) => this.toggleFilter(e)}
          />
          <span className="icon-search" />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { organizationFailedTnxList, getOrganization } = state;
  const { params } = organizationFailedTnxList.data;

  const organization = getOrganization?.success?.name;

  return { params, organization };
}

export default connect(mapStateToProps)(OrganizationFailedFilters);
